import React, { Dispatch } from "react";
import { Box } from "@mui/system";
import { ProjectsHighlightsGrid } from "./ProjectsHighlightsGrid";
import data from "../../data/projects.json";
import { Project, ProjectsAction } from "../../types";

interface ProjectsHighlightsProps {
  onSafetyClick?: (dispatch: Dispatch<ProjectsAction>, project: Project) => void;
  dispatch?: Dispatch<ProjectsAction>;
  disableProjectRandomization?: boolean;
  projectCategoryFilters?: string[];
  highlightedOnly?: boolean;
  disableSortById?: boolean;
}

export const ProjectsHighlights: React.FC<ProjectsHighlightsProps> = (props) => {
  const {
    onSafetyClick,
    dispatch,
    disableProjectRandomization,
    projectCategoryFilters,
    highlightedOnly,
    disableSortById,
  } = props;

  const { projects } = data;

  const filteredProjects =
    projectCategoryFilters && projectCategoryFilters.length
      ? projects.filter((e) => projectCategoryFilters.includes(e.category))
      : projects;

  return (
    <Box sx={{ overflow: "hidden" }}>
      {/* <Typography text="secondary">Highlights</Typography> */}
      <ProjectsHighlightsGrid
        onSafetyClick={onSafetyClick}
        dispatch={dispatch}
        projects={filteredProjects}
        disableProjectRandomization={disableProjectRandomization}
        highlightedOnly={highlightedOnly}
        disableSortById={disableSortById}
      />
    </Box>
  );
};
